// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2rVjy","title":"ClientReferral_title__1f01j","itemText":"ClientReferral_itemText__KqWP8"};